import {classNames} from "shared/lib/classNames/classNames";
import cls from "./HeroImage.module.scss";

interface HeroImageProps {
    img: string;
    className?: string;
    alt?: string;
}

const HeroImage = ({img, className, alt = "img"}: HeroImageProps) => {
    return (
        <div className={classNames(cls.HeroImage, {}, [className])}>
            <img
                src={img}
                className={cls.HeroImage__cover}
                alt={alt}
            />
        </div>
    )
};

export default HeroImage;

